import { render } from "./ResumeView.vue?vue&type=template&id=22512489&scoped=true"
import script from "./ResumeView.vue?vue&type=script&lang=js"
export * from "./ResumeView.vue?vue&type=script&lang=js"

import "./ResumeView.vue?vue&type=style&index=0&id=22512489&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22512489"]])

export default __exports__